import React from "react";
import GlobalForm from "@/components/forms/GlobalForm";
import {
  FinanceAndAccountingSubcategory,
  FormHeading,
  SuccessMessageType,
  VerticalCategory,
} from "@/interface/types";
import Image from "next/image";

const USPPoweredByMobile: React.FC = () => {
  return (
    <>
      <div className="py-10 px-6">
        <div>
          <h2 className="sans_bold font-bold md:text-[#FFBA08] text-[#FDA549] md:text-[76px] text-[28px] md:text-left text-center leading-[1.1] mb-8">
            Your Pathway <br className="md:block hidden" /> to the US.
            <br /> Powered by <br className="md:block hidden" /> Miles
          </h2>
        </div>
        <div
          className="p-4 border border-white rounded-2xl"
          style={{
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.30) 0%, rgba(51, 153, 255, 0.30) 100%)",
            boxShadow: "0px 0px 14px 0px rgba(4, 84, 175, 0.29)",
            backdropFilter: "blur(28px)",
          }}
        >
          <Image
            src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit/starGroup.webp"
            alt="star group"
            width={34}
            height={38}
            className="absolute top-1 left-0"
          />
          <GlobalForm
            course="USP"
            courseId={3}
            formHeading={FormHeading.WORLD_FAVORITE_CMA_CPA_INSTRUCTOR}
            formType="page"
            isAStepperForm={true}
            pageType="business page"
            subCategory={FinanceAndAccountingSubcategory.USP}
            submitButtonName="Download Brochure"
            successMessage={SuccessMessageType.ACCOUNTING}
            verticalName={VerticalCategory.FINANCE_AND_ACCOUNTING}
            showSVG={false}
            darkBackground={false}
          />
        </div>
      </div>
    </>
  );
};

export default USPPoweredByMobile;
